import { CampaignLabel } from 'campaigns-lib/campaignsPlatform';
import { Flex } from 'foundations-components/components/Flex';
import { Spacer } from 'foundations-components/components/Spacer';
import SummaryHeaderTitle from './SummaryHeaderTitle';
import SummaryHeaderGDPRToggle from './SummaryHeaderGDPRToggle';
import SummaryHeaderImage from './SummaryHeaderImage';
import SummaryHeaderAnalytics from './SummaryHeaderAnalytics';
import SummaryHeaderDescription from './SummaryHeaderDescription';
import DocumentBrandProperty from 'documents-ui/components/brand/DocumentBrandProperty';
import { isMultiBrandEnabled } from 'documents-lib/js/utils/isMultiBrandEnabled';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SummaryHeaderContent = ({
  documentId,
  documentMetadata,
  gdprSettings,
  updateDocument,
  updateDocumentGDPRSetting
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    flexGrow: 1,
    children: [/*#__PURE__*/_jsx(Flex, {
      flexGrow: 0,
      children: /*#__PURE__*/_jsx(SummaryHeaderImage, {
        documentId: documentId,
        thumbnailUrl: documentMetadata.get('thumbnailUrl'),
        progressionPercent: documentMetadata.get('progressionPercent')
      })
    }), /*#__PURE__*/_jsxs(Flex, {
      marginInlineEnd: "500",
      flexDirection: "column",
      inlineSize: "0",
      flexGrow: 1,
      children: [/*#__PURE__*/_jsx(SummaryHeaderTitle, {
        documentId: documentId,
        documentMetadata: documentMetadata,
        updateDocument: updateDocument
      }), /*#__PURE__*/_jsx(SummaryHeaderDescription, {
        deckId: documentId
      }), /*#__PURE__*/_jsxs(Flex, {
        alignItems: "start",
        gap: "600",
        flexWrap: "wrap",
        children: [isMultiBrandEnabled() && /*#__PURE__*/_jsx(DocumentBrandProperty, {
          brandId: documentMetadata.get('brandId')
        }), /*#__PURE__*/_jsx(CampaignLabel, {
          objectType: "SALES_DOCUMENT",
          assetId: documentId,
          crmIdProperty: "hs_document_id"
        })]
      }), /*#__PURE__*/_jsx(Spacer, {
        space: "300"
      }), /*#__PURE__*/_jsx(SummaryHeaderGDPRToggle, {
        documentId: documentId,
        documentMetadata: documentMetadata,
        gdprSettings: gdprSettings,
        updateDocumentGDPRSetting: updateDocumentGDPRSetting
      }), /*#__PURE__*/_jsx(SummaryHeaderAnalytics, {
        documentId: documentId,
        numShares: documentMetadata.get('numShares'),
        numUniqueVisitors: documentMetadata.get('numUniqueVisitors'),
        numViews: documentMetadata.get('numViews')
      })]
    })]
  });
};
export default SummaryHeaderContent;